<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto">
          <div style="margin: 0 20px 0 0;height: 50px">
            <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
          </div>
          <div style="margin: 0 20px 0 0;">
            <el-tree class="filter-tree" show-checkbox :data="treeData" :props="defaultProps" node-key="id" :default-expanded-keys="expandedKeys"
                     :default-checked-keys="isFirst" @node-click="handleTreeClick" @check-change="handleCheckChange" :filter-node-method="filterNode" ref="treeData">
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto">
          <div style="height: 50px;">
            <el-date-picker v-fixZoom
              :clearable="false"
              v-model="alarmDate"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions2"
              value-format="yyyyMMdd"
              style="margin-right: 10px; width: 400px">
            </el-date-picker>
            <el-input
              prefix-icon="el-icon-search"
              placeholder="输入服务对象搜索"
              v-model="searchKeyword"
              style="width: 350px"
              @blur="blurSearch()">
            </el-input>&nbsp;
            <el-button type="primary" @click="getAllHistoryWithCid">查询</el-button>
            <el-button v-if="$store.state.user.role !== 'csd'" icon="el-icon-download" type="success" @click="downloadAlarm">导出</el-button>
          </div>
          <div style="max-height: calc(100% - 110px);overflow-y: auto;">
            <el-table
              v-loading="loading"
              element-loading-text="加载中，请耐心等待。"
              :data="showTable"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <el-table-column
                type="index"
                label="序号"
                width="70"
                align="center">
              </el-table-column>
              <el-table-column
                label="事件类型"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span>{{getAType(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="time"
                label="事件时间"
                min-width="130"
                align="center">
              </el-table-column>
              <el-table-column label="楼栋/楼层/房间" min-width="120" align="center" v-if="$store.state.user.moduletag === 2">
                <template slot-scope="scope">
                  <span v-if="scope.row.device">{{scope.row.device.build_name}} / {{scope.row.device.floor_name}} / {{scope.row.device.home_room}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="o_name"
                label="所属组织"
                min-width="75"
                align="center" v-if="$store.state.user.moduletag !== 2">
              </el-table-column>
              <el-table-column
                prop="orglevelname"
                label="所属区域"
                min-width="90"
                align="center" v-if="$store.state.user.moduletag !== 2">
              </el-table-column>
              <el-table-column
                prop="projectName"
                label="所属项目"
                min-width="70"
                align="center" v-if="$store.state.user.moduletag !== 2">
              </el-table-column>
              <el-table-column
                prop="p_name"
                label="服务对象"
                min-width="70"
                align="center">
              </el-table-column>
              <el-table-column
                label="性别"
                width="50"
                align="center" v-if="$store.state.user.moduletag !== 2">
                <template slot-scope="scope">
                  <span>{{getSex(scope.row.p_sex)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="出生日期"
                min-width="80"
                align="center" v-if="$store.state.user.moduletag !== 2">
                <template slot-scope="scope">
                  <span>{{scope.row.p_birthday}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="家庭地址"
                min-width="120" v-if="$store.state.user.moduletag !== 2">
                <template slot-scope="scope">
                  <span>{{scope.row.h_address}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="设备类型"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <img v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(scope.row)">
                  <span v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')">{{getDeviceType(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="h_install_location"
                label="安装位置"
                min-width="70"
                align="center">
              </el-table-column>
              <el-table-column
                prop="handletypename"
                label="服务类型"
                min-width="70"
                align="center" v-if="$store.state.user.moduletag !== 2">
              </el-table-column>
              <el-table-column
                label="处理情况"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span :style="scope.row.ishandle === 0 ? 'color: blue' : 'color: green'">{{getIsHandle(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80"
                align="center">
                <template slot-scope="scope">
                  <el-button @click="openDetails(scope.row)" size="mini" type="primary" plain>详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
            <el-pagination v-fixZoom
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="alarmShow" v-if="alarmShow" width="950px" :close-on-click-modal="true" :show-close="true" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>报警详情</span> </div>
        <div class="line-title"></div>
      </div>
      <alarm-details-new :details="alarmObj" v-model="alarmShow"></alarm-details-new>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {queryalarm, searchalarmbyperson} from '../../api/alarmservice'
import {querydevicebydids} from '../../api/device'
import {queryfrequency, queryproject, queryoldperson} from '../../api/serviceObject'
import {queryorghome} from '../../api/relation'
import {queryorgcommunity} from '../../api/community'
import alarmDetailsNew from './childComponents/alarmDetailsNew'

export default {
  name: 'alarmService',
  components: {alarmDetailsNew},
  data () {
    return {
      imgIcon: [],
      alarmShow: false,
      alarmObj: {
        row: '',
        projects: [],
        frequencys: [],
        orgcommunitys: []
      },
      // 左边
      orgData: [],
      searchKeyword: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      // 右边
      alarmDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      filename: '历史警报记录',
      autoWidth: true,
      projects: [],
      orgid: '',

      dids: [],
      sendDids: [],
      devices: [],
      isSendDevice: true,
      hid: [],
      homes: [],
      isHome: true,
      pid: [],
      oldperson: [],
      isPerson: true,

      orghomes: [],
      oldpersons: [],
      frequencys: [],
      orgcommunitys: [],
      downData: []
    }
  },
  created () {
    // 事件/服务统计
    this.golobleObject.searchOldPerson = this.getSearchName
    this.orgid = this.$store.state.user.orgid
    this.imgIcon = this.getImgArr.getImgIconDevice()
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyyMMdd')
    const start = new Date()
    start.setDate(1)
    this.alarmDate = [start.format('yyyyMMdd'), date]
    this.getFrequency()
    this.getCommunityData()
  },
  mounted () {
  },
  computed: {},
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    getSearchName (name) {
      this.searchKeyword = name
      this.querySearchAlarm()
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + arr[1] + '01'
        obj.end = arr[0] + arr[1] + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
      this.getOrgData()
    },
    // 左边树
    handleTreeClick (item) {},
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      // console.log(this.isFirst)
      if (this.searchKeyword === '') {
        this.queryAlarm()
      } else {
        this.querySearchAlarm()
      }
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      this.loading = true
      queryorg().then(res => {
        // this.getFrequency()
        this.getProjects()
        if (this.$store.state.user.moduletag === 2) {
          this.orgData = res.data.org
        } else {
          this.orgData = res.data.org.filter(item => {
            if (item.org_type === 0) {
              return item
            }
          })
        }
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].orgpid === -1) {
            this.expandedKeys.push(this.orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = this.orgData
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          if (this.expandedKeys.length === 0) {
            this.expandedKeys.push(this.treeData[i].id)
          }
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getTypeImg (row) {
      let type = ''
      if (row.device) {
        type = row.device.devicetype
      }
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (row) {
      let type = 0
      if (row.device) {
        type = row.device.devicetype
      }
      if (this.$store.state.user.moduletag === 2) {
        if (type === 700) {
          return '智能网关'
        }
      }
      return this.commonType.getDeviceType(type)
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    },
    getIsHandle (row) {
      let handle = ''
      if (row.ishandle === 1) {
        handle = '已处理'
      } else if (row.ishandle === 0) {
        handle = '未处理'
      }
      return handle
    },
    // 所属小区
    getCommunityData () {
      queryorgcommunity().then(res => {
        this.orgcommunitys = res.data.orgcommunitys
        this.alarmObj.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.alarmObj.frequencys = this.frequencys
        // this.getProjects()
      }).catch(() => {})
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.orgid
      }
      queryproject(data).then(res => {
        if (this.searchKeyword !== '') {
          this.querySearchAlarm()
        } else {
          this.queryAlarm()
        }
        this.projects = res.data.projects
        this.alarmObj.projects = this.projects
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询家庭
    getQueryOrgHome () {
      queryorghome().then(res => {
        this.orghomes = res.data.orghomes
        this.alarmObj.orghomes = this.orghomes
        // this.getOldPerson()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务对象信息
    getOldPerson () {
      let data = {
        orgid: this.orgid
      }
      queryoldperson(data).then(res => {
        this.oldpersons = res.data.oldpersons
        this.alarmObj.oldpersons = this.oldpersons
        // this.queryAlarm()
      }).catch(() => {
        this.loading = false
      })
    },
    // 表格数据
    queryAlarm () {
      // console.log(222, this.alarmDate)
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959',
        oid: this.isFirst
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryalarm(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
            this.sendDids.push(this.tableData[i].did)
          }
        }
        if (oldDids === this.dids.length) {
          this.isSendDevice = false
        } else {
          this.isSendDevice = true
        }
        this.getDevices()
      }).catch(() => {})
    },
    // 搜索表格
    querySearchAlarm () {
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959',
        name: this.searchKeyword,
        oid: this.isFirst
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      searchalarmbyperson(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
            this.sendDids.push(this.tableData[i].did)
          }
        }
        if (oldDids === this.dids.length) {
          this.isSendDevice = false
        } else {
          this.isSendDevice = true
        }
        this.getDevices()
      }).catch(() => {})
    },
    // 获取设备
    getDevices () {
      if (this.isSendDevice) {
        let data = {
          dids: this.sendDids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          // console.log(this.devices)
          this.getEndTable()
        }).catch(() => {
        })
      } else {
        this.getEndTable()
      }
    },
    getEndTable () {
      const tempList = this.tableData
      this.tableData = []
      this.showTable = []
      let arr = []
      for (let i = 0; i < tempList.length; i++) {
        let obj = tempList[i]
        obj.device = null
        obj.projectName = this.getProjectName(obj.p_projectid)
        for (let j = 0; j < this.devices.length; j++) {
          if (obj.did === this.devices[j].id) {
            obj.device = this.devices[j]
            // if (obj.id === 57440) {
            //   console.log('有', obj, this.devices[j])
            // }
          }
        }
        // if (obj.id === 57440) {
        //   console.log(57440, obj)
        // }
        arr.push(obj)
      }
      this.showTable = arr
      // console.log(111, this.showTable)
    },
    getProjectName (projectid) {
      for (let i = 0; i < this.projects.length; i++) {
        if (projectid === this.projects[i].id) {
          return this.projects[i].projectname
        }
      }
    },
    openDetails (row) {
      // console.log(111, row)
      this.alarmObj.row = row
      this.alarmShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        this.queryAlarm()
      } else {
        this.querySearchAlarm()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        this.queryAlarm()
      } else {
        this.querySearchAlarm()
      }
    },
    blurSearch () {
      this.searchKeyword = this.searchKeyword.replace(/\s*/g, '')
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.pageSize = 10
        this.queryAlarm()
      }
    },
    getAllHistoryWithCid () {
      if (this.searchKeyword === '') {
        this.queryAlarm()
      } else {
        this.querySearchAlarm()
      }
    },
    downloadAlarm () {
      this.$message({
        type: 'info',
        message: '数据加载中，请耐心等待。',
        duration: 0
      })
      let params = {
        page: 1,
        size: 10
      }
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959',
        oid: this.isFirst
      }
      queryalarm(params, data).then(res => {
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        } else {
          this.download1(res.data.cnt)
        }
      }).catch(() => {})
    },
    download1 (cnt) {
      let params = {
        page: 1,
        size: cnt
      }
      let data = {
        from: this.alarmDate[0] + '000000',
        to: this.alarmDate[1] + '235959',
        oid: this.isFirst
      }
      queryalarm(params, data).then(res => {
        this.downData = res.data.alarms
        let oldDids = this.dids.length
        for (let i = 0; i < res.data.alarms.length; i++) {
          if (this.dids.indexOf(res.data.alarms[i].did) === -1) {
            this.dids.push(res.data.alarms[i].did)
            this.sendDids.push(res.data.alarms[i].did)
          }
        }
        if (oldDids === this.dids.length) {
          this.isSendDevice = false
        } else {
          this.isSendDevice = true
        }
        this.getDevices1()
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    // 获取设备
    getDevices1 () {
      if (this.isSendDevice) {
        let data = {
          dids: this.sendDids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          // console.log(this.devices)
          this.getEndTable1()
        }).catch(() => {
        })
      } else {
        this.getEndTable1()
      }
    },
    getEndTable1 () {
      // console.log('--')
      const tempList = this.downData
      this.downData = []
      let arr = []
      for (let i = 0; i < tempList.length; i++) {
        let obj = tempList[i]
        obj.alarmTypeShow = this.getAType(obj)
        obj.sexShow = this.getSex(obj.p_sex)
        obj.deviceTypeShow = ''
        obj.handleShow = this.getIsHandle(obj)
        obj.projectName = this.getProjectName(obj.p_projectid)
        let device = null
        for (let j = 0; j < this.devices.length; j++) {
          if (tempList[i].did === this.devices[j].id) {
            device = this.devices[j]
          }
        }
        tempList[i].device = device
        if (this.$store.state.user.moduletag === 2) {
          obj.addressName = device.build_name + ' / ' + device.floor_name + ' / ' + device.home_room
        }
        obj.deviceTypeShow = this.getDeviceType(tempList[i])
        arr.push(obj)
      }
      // console.log(667788, this.downData)
      this.download2(arr)
    },
    download2 (arr) {
      // console.log(998877, arr)
      if (this.$store.state.user.moduletag !== 2) {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['事件类型', '事件时间', '所属组织', '所属区域', '所属项目', '服务对象', '性别', '出生日期', '家庭地址', '设备类型', '安装位置', '服务类型', '处理情况']
          const filterVal = ['alarmTypeShow', 'time', 'o_name', 'orglevelname', 'projectName', 'p_name', 'sexShow', 'p_birthday', 'h_address', 'deviceTypeShow', 'h_install_location', 'handletypename', 'handleShow']
          const list = arr
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth
          })
        })
      } else {
        import('../../vendor/Export2Excel').then(excel => {
          const tHeader = ['事件类型', '事件时间', '楼栋/楼层/房间', '服务对象', '出生日期', '设备类型', '安装位置', '服务类型', '处理情况']
          const filterVal = ['alarmTypeShow', 'time', 'addressName', 'p_name', 'p_birthday', 'deviceTypeShow', 'h_install_location', 'handletypename', 'handleShow']
          const list = arr
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth
          })
        })
      }
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/alarmService.vue